import * as React from 'react';

export const QuizEditorIsUploadingImageContext = React.createContext<{
  finishUploading: () => void;
  beginUploading: () => void;
  isUploadingImages: boolean;
}>({
  finishUploading: () => {},
  beginUploading: () => {},
  isUploadingImages: false,
});

export const QuizEditorIsUploadingImageProvider = (props) => {
  const [imagesUploadingCount, setImagesUploadingCount] = React.useState(0);
  const beginUploading = React.useCallback(
    () => setImagesUploadingCount(imagesUploadingCount + 1),
    [setImagesUploadingCount, imagesUploadingCount]
  );
  const finishUploading = React.useCallback(
    () => setImagesUploadingCount(Math.max(0, imagesUploadingCount - 1)),
    [setImagesUploadingCount, imagesUploadingCount]
  );

  const isUploadingImages = React.useMemo(
    () => imagesUploadingCount > 0,
    [imagesUploadingCount]
  );

  const value = React.useMemo(
    () => ({ beginUploading, finishUploading, isUploadingImages }),
    [beginUploading, finishUploading, isUploadingImages]
  );

  return (
    <QuizEditorIsUploadingImageContext.Provider value={value}>
      {props.children}
    </QuizEditorIsUploadingImageContext.Provider>
  );
};
